export default __webpack_public_path__ + "static/media/europe.b34f9cd9.png";